import React from 'react';
import utils from '../../helpers/utils';

const CloseIcon = () => (
  <img src={utils.getCdnPath('/close.png')} className="w-6 h-6 md:w-10 md:h-10 cursor-pointer" alt="close"/>
);

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/components/common/CloseIcon.js